import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { gameOver } from "../../redux/actions/actions";
import "./RemainingLivesDisplay.css";

const RemainingLivesDisplay = () => {
  const dispatch = useDispatch();
  const remainingLives = useSelector((state) => state.game.remainingLives);
  const isGameStarted = useSelector((state) => state.game.isGameStarted);
  
  useEffect(() => {
    if (remainingLives <= 0) dispatch(gameOver({outcome: "Vessel Destroyed"}));
  }, [remainingLives, dispatch]);
  
  return (
    <div data-testid="remaining-lives-component">
      {isGameStarted && <p className="lives-font">Lives: {remainingLives}</p>}
    </div>
  );
};

export default RemainingLivesDisplay;
